import React from 'react'
import { connect } from 'react-redux'
import { storage } from '../../utils'


class WkGlobalTopTip extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowMyself: false,
        }
        this.duration = 25000
        this.cacheField = 'wk-is-close-global-top-tip-180309'
    }
    componentDidMount () {
        if (/*storage.getItem(this.cacheField) || */Date.now() > Date.parse('2018/06/05 08:00:00')) {
           return
        }
        const $text = this.$text
        if (!$text) {
            return
        }
        const textWidth = $text.getBoundingClientRect().width
        this.startScroll(textWidth)
        this.setState({ isShowMyself: true })
    }

    startScroll (textWidth) {
        let noUse
        this.$text.setAttribute('style', `transition: none`)
        noUse = this.$text.getBoundingClientRect().right
        this.$text.setAttribute('style', `transform: translateX(${textWidth}px)`)
        noUse = this.$text.getBoundingClientRect().right
        this.$text.setAttribute('style', `transform: translateX(${-textWidth - 30}px);transition: all ${this.duration / 1000}s linear`)
        this.timeouter = setTimeout(() => {
            this.startScroll(textWidth)
        }, this.duration + 1000)
    }

    handleClickClose() {
        storage.setItem(this.cacheField, 1)
        this.setState({ isShowMyself: false })
        clearTimeout(this.timeouter)
    }

    render() {
        return (
            <div className="wk-global-top-tip" style={{opacity: this.state.isShowMyself ? '1' : '0'}}>
                <div className="content">
                    <div className="text-wrap">
                        <div className="text">
                        <span ref={r => this.$text = r}>
                            紧急通知：因服务器临时升级，即刻起平台暂停开课服务，预计5号早上8:00后恢复正常。
                        </span>
                        </div>
                    </div>
                    <div className="close" onClick={() => this.handleClickClose()}>
                        <i className="iconfont icon-cuowu"></i>
                    </div>
                </div>
            </div>
        )
    }
}


export default connect(state => ({
    
}))(WkGlobalTopTip)



// WEBPACK FOOTER //
// ./src/components/wk/WKGlobalTopTip.js